import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import check from '../utils/check';
import checkNot from '../utils/checkNot';
import restrict from '../utils/restrict';

export default class BrandApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }
  // =============================================================================
  //                                  BRAND APIs
  // =============================================================================

  public BrandShow(id: number, options: any = {}) {
    // Build query
    const query = `/core/v1/brand/${id}`;
    let parameters = '?alk=1';
    if (checkNot(options.with_children, ['undefined', 'null', 'empty'])) {
      parameters += '&with_children=1';
      parameters += '&with_subbrands=1';
    }
    if (checkNot(options.with_subbrands, ['undefined', 'null', 'empty'])) {
      parameters += '&with_children=1';
      parameters += '&with_subbrands=1';
    }
    return this.get(query, parameters);
  }

  public BrandList(
    queries: any = {},
    filters: any = {},
    offset?: number,
    limit?: number,
    withs: any = {},
  ) {
    // Build query
    const query = '/core/v1/brand';
    let parameters = '?alk=1';
    if (checkNot(queries.name, ['undefined', 'null', 'empty'])) {
      parameters += `&like_name=${queries.name}`;
    }
    if (checkNot(queries.noCache, ['undefined', 'null', 'empty'])) {
      parameters += `&no_cache=${queries.noCache}`;
    }
    if (checkNot(queries.full, ['undefined', 'null', 'empty'])) {
      parameters += `&full=${queries.full}`;
    }
    if (checkNot(filters.id, ['undefined', 'null', 'empty'])) {
      parameters += `&filter_id_in=${filters.id}`;
    }
    if (checkNot(filters.managedByUser, ['undefined', 'null', 'empty'])) {
      parameters += `&managed_by_user=${filters.managedByUser}`;
    }
    if (checkNot(withs.subbrands, ['undefined', 'null', 'empty'])) {
      parameters += `&with_subbrands=${+withs.subbrands}`;
    }
    if (checkNot(offset, ['undefined', 'null', 'empty'])) {
      parameters += `&offset=${offset}`;
    }
    if (checkNot(limit, ['undefined', 'null', 'empty'])) {
      parameters += `&limit=${limit}`;
    }
    return this.get(query, parameters);
  }

  public BrandCreate(brand: any) {
    const query = '/core/v1/brand';
    if (!brand) {
      const error = {
        message: 'Missing parameter : brand',
        name: 'bad parameter',
      };
      throw error;
    }
    return this.post(query, brand);
  }

  public BrandUpdate(brand: any, fields: any) {
    if (!brand) {
      const error = {
        message: 'Missing parameter : brand',
        name: 'bad parameter',
      };
      throw error;
    }
    if (check(brand.id, ['undefined', 'null', 'empty'])) {
      const error = {
        message: 'Missing parameter : brand.id',
        name: 'bad parameter',
      };
      throw error;
    }
    const query = `/core/v1/brand/${brand.id}`;
    const parameters = restrict(brand, fields);
    if (Object.keys(parameters).length === 0) {
      const error = {
        message: `No field to update in Brand ${brand.id}`,
        name: 'bad parameter',
      };
      throw error;
    }
    return this.put(query, parameters);
  }
}
